import { render, staticRenderFns } from "./FactSheetManage.vue?vue&type=template&id=4251b548&"
import script from "./FactSheetManage.vue?vue&type=script&lang=js&"
export * from "./FactSheetManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports